

function openCartDrawer() {
  setTimeout(function() {
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  }, 1400); // 2000 milliseconds = 2 seconds
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}


jQuery(document).ready(function( $ ) {
    $('.product-form__cart-submit').on('click', function(event) {
      if ($(this).text().trim() === "Add to cart") {
          openCartDrawer();
      }
  });

    $('.cart-drawer-header-right-close').on('click', function(event) {
        closeCartDrawer()
    });

    $('.cart-popup__dismiss-button').on('click', function(event) {
        closeCartDrawer()
    });

    // Event listener to close the cart drawer when clicking outside of it
    $(document).on('click', function(event) {
      var $cartDrawer = $('.cart-drawer');
      if (!$cartDrawer.is(event.target) && $cartDrawer.has(event.target).length === 0) {
        closeCartDrawer();
      }
    });
});


